import React, { Component } from 'react';
import Constants from '../../../definitions/constants';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import toastr from 'toastr';

import Select from '../common/inputs/select';
import TextBox from '../common/inputs/textBox';

const initialObjectState = {
  order: "",
  metric_id: "",
  join_type: "",
  foreign_metric_join_column_id: "",
  join_column_id: "",
  foreign_metric_join_column_transform: "",
  join_column_transform: "",
}

class MetricJoinSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toAddObject: JavascriptUtilsTooling.deepCopy(initialObjectState),
      toAddObjectPosition: 0,      
      toEditObjectPosition: null,   
      toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
    };
  }
  
  componentDidUpdate(prevProps, prevState) {
    if(!prevState.showOverlay && this.state.showOverlay) {
      InterfaceTooling.bringObjectEditorInputIntoView();
    }
  }
  
  isValidObject = (object, index) => {
    if(((!object.foreign_metric_join_column_id || !object.join_column_id || !object.metric_id || !object.join_type) && index!=0) || (index==0 && !object.metric_id)){
      toastr.options = Constants.interface.tostrOptions;
      toastr.error(intl.formatMessage({ id: "virtualMetricAdmin.joins.emptyFieldsError"}));
      return false;
    }
    return true;
  };
    
  handleAddButtonClick = (event) => {
    if(this.editItemInput) {
      this.editItemInput.focus();
    }
  };

  handleCancelAdd = (event) => {
    this.setState({
      showOverlay: false,
      toAddObjectPosition: null,
      toAddObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
    });
  };

  handleChangeAddItem = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    var toAddObject = JavascriptUtilsTooling.deepCopy(this.state.toAddObject);
    if(event.currentTarget.dataset.path == "metric_id"){ 
      toAddObject.join_column_id= ''
    }
    toAddObject[event.currentTarget.dataset.path] = value;
    this.setState({
      showOverlay: true,
      toAddObject: toAddObject
    });    
  };

  handleOnEnterAddItem = (event) => {
    if(this.addItemSaveButton) {
      this.addItemSaveButton.click();
    }
  };

  handleSaveAddItem = (event) => {
    if(this.isValidObject(this.state.toAddObject, this.state.toAddObjectPosition)) {
      event.currentTarget.joinSelector = true;
      this.props.onChange(event);
      this.setState({
        showOverlay: false,
        toAddObjectPosition: null,
        toAddObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
      });
    }
  };

  handleClickEdit = (event) => {
    let itemIndex = event.currentTarget.dataset.index;    
    let objectToEdit = JSON.parse(event.currentTarget.dataset.value);
    this.setState({    
      showOverlay: true,  
      toEditObjectPosition: itemIndex,
      toEditObject: objectToEdit
    });
  };

  handleChangeEdit = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    var toEditObject = JavascriptUtilsTooling.deepCopy(this.state.toEditObject);
    if(event.currentTarget.dataset.path == "metric_id"){
      toEditObject.join_column_id= '' 
    }
    toEditObject[event.currentTarget.dataset.path] = value;
    this.setState({
      toEditObject: toEditObject
    });  
  };

  handleCancelEdit = (event) => {
    this.setState({
      showOverlay: false,
      toEditObjectPosition: null,
      toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
    });
  };

  handleSaveEditItem = (event) => {
    let index = event.currentTarget.dataset.index;
    if(this.isValidObject(this.state.toEditObject, this.state.toEditObjectPosition)) {
      event.currentTarget.joinSelector = true;
      this.props.onChange(event);
      this.setState({
        showOverlay: false,
        toEditObjectPosition: null,
        toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
      });   
    }     
  };

  handleOnEnterEditItem = (event) => {
    if(this.editItemSaveButton) {
      this.editItemSaveButton.click();      
    }   
  };

  handleDeleteItem = (event) => {
    event.currentTarget.joinSelector = true;
    if(this.props.values.length == 1) {
      this.setState({
        toAddObjectPosition: 0,
      });
    }      
    this.props.onChange(event);
  }

  render() {
    const {
      className,
      values,
      onChange,
      metricsList,
      dimensionsList,
      getSelectKeysFromArrayWithMetricHandler,
      handleShowAllTextClick,
      showAllTextInJoins,
      disabled
    } = this.props;
    const dataPath = this.props["data-path"];    
    let activeMetrics = [];
    values.forEach((item,i) => {
      if(i!=this.state.toEditObjectPosition){
        activeMetrics.push(+item.metric_id);
      }
    });
    let metricOptions = InterfaceTooling.getSelectArrayFromArrayOfObjects(metricsList, "id", "name"); 
    metricOptions = metricOptions ? metricOptions.filter(item => !activeMetrics.includes(item.value) || this.state.toEditObject.metric_id == item.value) : [];
    let blockAdd = metricOptions.length > 1 ? false : true;
    let upperMetricsIds = []
    let selectedUpperMetricsDimensionsList = []
    let destinyColumnMetricId = null
    if(this.state.toEditObjectPosition != null) {
      upperMetricsIds = values.slice(0, this.state.toEditObjectPosition).map(item => +item.metric_id);
      destinyColumnMetricId = +values[this.state.toEditObjectPosition].metric_id
    }
    else{
      upperMetricsIds = values.map(item => +item.metric_id);
      destinyColumnMetricId = +this.state.toAddObject.metric_id
    }
    metricsList.map(metric => {
      if(upperMetricsIds.includes(metric.id)) {
        metric.dimensions.map(dimension => {
          selectedUpperMetricsDimensionsList = selectedUpperMetricsDimensionsList.concat([{...dimension, metric_id: metric.id}])
        })
        if(metric.data_type == 'object'){
          selectedUpperMetricsDimensionsList = selectedUpperMetricsDimensionsList.concat([{...metric, metric_id: metric.id, isMetricValue: true}])
        }
        else{
          selectedUpperMetricsDimensionsList = selectedUpperMetricsDimensionsList.concat([{...metric, metric_id: metric.id, isMetricValue: true}])
        }
      }
    })    
    let foreignColumnIdOptions = getSelectKeysFromArrayWithMetricHandler(selectedUpperMetricsDimensionsList, "id", "name", "metric_id");

    let destinationDimensions = metricsList.find(item => item.id == destinyColumnMetricId) ? metricsList.find(item => item.id == destinyColumnMetricId).dimensions : [];
    if(destinationDimensions.length > 0) {
      let destinationMetric = metricsList.find(item => item.id == destinyColumnMetricId)
      if(destinationMetric.data_type == 'object'){
        destinationMetric.object_definition.map(prop => {
          destinationDimensions = destinationDimensions.concat([{...destinationMetric, id: "v_"+prop.id, isMetricValue: true, name: intl.formatMessage({id: "virtualMetricAdmin.joins.metricValueLabel"})+"."+prop.name}])
        })
      }
      else{
        destinationDimensions = destinationDimensions.concat([{...destinationMetric, id: "v", isMetricValue: true, name: intl.formatMessage({id: "virtualMetricAdmin.joins.metricValueLabel"})}])
      }
    }
    let joinColumnIdOptions = InterfaceTooling.getSelectArrayFromArrayOfObjects(destinationDimensions, "id", "name");
    
    return (
      <div className={"custom-input free-text-list virtual_metric_join_input select-list object-editor object-template-headers-editor" + (className ? " " + className : "") + " select-list-no-search" + (className ? " " + className : "") + " select-list-no-search" + (this.state.showOverlay ? " free-text-list-overlay" : "")}>
        {this.state.showOverlay && (<div className="free-text-list-overlay-item"></div>)}
        <div className="free-text-list-label">
          <FormattedMessage id="virtualMetricAdmin.metricJoinSelector.header"/>
          {(!disabled && !blockAdd)
           }
          <i className={"fas " + (showAllTextInJoins ? "fa-eye-slash" : "fa-eye")} onClick={handleShowAllTextClick} title={intl.formatMessage({id: "virtualMetricAdmin.joins.showAllTextIconLabel"})}/>
        </div>
          <div className="free-text-list-list-wrapper">
            {values && values.map((item,i) => {
              if(this.state.toEditObjectPosition == i) {
                return (
                  <div key={i} className="free-text-list-list-item free-text-list-list-item-edit virtual_metric_join_selector">
                    <div className="free-text-list-list-item-inner object-editor-inputs">
                      <div className="object-editor-inputs-linebreak"> 
                        <Select 
                          className="free-text-list-list-add-item"
                          value={this.state.toEditObject.metric_id}
                          labelLocale={<FormattedMessage id="virtualMetricAdmin.fields.joins.metric_id"/>}
                          options={metricOptions ? metricOptions : []}
                          onChange={this.handleChangeEdit}
                          data-path={"metric_id"}
                        />
                        {this.state.toEditObjectPosition != 0 && (
                          <Select 
                            className="free-text-list-list-add-item metric_join_type_select"
                            value={this.state.toEditObject.join_type}
                            labelLocale={<FormattedMessage id="virtualMetricAdmin.fields.joins.join_type"/>}
                            options={InterfaceTooling.getSelectArray("selectKeys.virtualMetric.joinType","virtualMetricAdmin.joins.joinTypeOptions")}
                            onChange={this.handleChangeEdit}
                            data-path={"join_type"}
                          />
                        )}  
                        {/* <TextBox
                          className="free-text-list-list-add-item"
                          styleType={Constants.interface.inputs.styleType.OUTLINED}
                          onChange={this.handleChangeEdit}
                          data-path={"order"}
                          value={this.state.toEditObject.order}
                          onKeyEsc={this.handleCancelEdit}
                          onKeyEnter={this.handleOnEnterEditItem}
                          type={Constants.interface.inputs.type.TEXT}
                          labelLocale={<FormattedMessage id="virtualMetricAdmin.fields.joins.order"/>}
                        /> */}
                      </div>
                      {this.state.toEditObjectPosition != 0 && (
                        <React.Fragment>                          
                          <div className="object-editor-inputs-linebreak">
                            <Select 
                              className="free-text-list-list-add-item"
                              value={this.state.toEditObject.foreign_metric_join_column_id}
                              labelLocale={<FormattedMessage id="virtualMetricAdmin.fields.joins.foreign_metric_join_column_id"/>}
                              options={foreignColumnIdOptions ? foreignColumnIdOptions : []}
                              onChange={this.handleChangeEdit}
                              data-path={"foreign_metric_join_column_id"}
                            />                                                
                            <Select 
                              className={"free-text-list-list-add-item" + (this.state.showOverlay ? " additional_input_required" : "")}
                              value={this.state.toEditObject.join_column_id}
                              labelLocale={<FormattedMessage id="virtualMetricAdmin.fields.joins.join_column_id"/>}
                              options={joinColumnIdOptions ? joinColumnIdOptions : []}
                              onChange={this.handleChangeEdit}
                              data-path={"join_column_id"}
                              disabled={this.state.toEditObject.metric_id == ''}
                            />
                          </div>
                          <div className="object-editor-inputs-linebreak">
                            <Select 
                              className="free-text-list-list-add-item"
                              value={this.state.toEditObject.foreign_metric_join_column_transform}
                              labelLocale={<FormattedMessage id="virtualMetricAdmin.fields.joins.foreign_metric_join_column_transform"/>}
                              options={InterfaceTooling.getSelectArray("selectKeys.virtualMetric.joinColumnsTransformations","virtualMetricAdmin.joins.joinMetricTransformationOptions")}
                              onChange={this.handleChangeEdit}
                              data-path={"foreign_metric_join_column_transform"}
                            />
                            <Select 
                              className="free-text-list-list-add-item form_buttons_item"
                              value={this.state.toEditObject.join_column_transform}
                              labelLocale={<FormattedMessage id="virtualMetricAdmin.fields.joins.join_column_transform"/>}
                              options={InterfaceTooling.getSelectArray("selectKeys.virtualMetric.joinColumnsTransformations","virtualMetricAdmin.joins.joinMetricTransformationOptions")}
                              onChange={this.handleChangeEdit}
                              data-path={"join_column_transform"}
                            />
                          </div>
                        </React.Fragment>
                      )}
                    </div>
                    {(!disabled && this.state.showOverlay) && (
                      <div className="free-text-list-list-item-action-buttons free-text-list-list-item-action-buttons-edit">
                        <i 
                          ref={(input) => { this.editItemSaveButton = input; }}
                          className="fas fa-save"
                          data-index={i}                        
                          data-value={JSON.stringify(this.state.toEditObject)}
                          data-objecteditor={"true"}
                          data-path={dataPath}
                          data-edit={"true"}
                          onClick={this.handleSaveEditItem}                      
                        />         
                        <i className="fas cancel-action fa-times-circle" onClick={this.handleCancelEdit}/>
                      </div>
                    )}
                  </div>
                );
              }
              else {
                let itemInnerText = metricsList.find(metric => metric.id==item.metric_id).name
                let incompleteData = false
                if(!(item.foreign_metric_join_column_id && item.join_type && item.join_column_id) && !(i == 0)){
                  itemInnerText += " (" + intl.formatMessage({id: "virtualMetricAdmin.incompleteDataText"}) + ")"
                  incompleteData = true
                }
                else if(i != 0) {
                  let foreign_metric_join_column_idLabel = metricsList.find(metric => metric.id==item.foreign_metric_join_column_id.split("_")[0]).name+"."
                  if(item.foreign_metric_join_column_id.split("_")[1] != "v"){
                    foreign_metric_join_column_idLabel += dimensionsList.find(dimension => dimension.id==item.foreign_metric_join_column_id.split("_")[1]).name
                  }
                  else if(item.foreign_metric_join_column_id.split("_").length == 3){
                    foreign_metric_join_column_idLabel += intl.formatMessage({id: "virtualMetricAdmin.joins.metricValueLabel"}) + "." + metricsList.find(metric => metric.id==item.foreign_metric_join_column_id.split("_")[0]).object_definition.find(prop => prop.id==item.foreign_metric_join_column_id.split("_")[2]).name
                  }
                  else{
                    foreign_metric_join_column_idLabel += intl.formatMessage({id: "virtualMetricAdmin.joins.metricValueLabel"})
                  }

                  let join_typeLabel = InterfaceTooling.getSelectArray("selectKeys.virtualMetric.joinType","virtualMetricAdmin.joins.joinTypeOptions").find(join_type => join_type.value==item.join_type).label
                  
                  let join_column_idLabel = metricsList.find(metric => metric.id==item.metric_id).name+"."
                  if(item.join_column_id == "v"){
                    join_column_idLabel += intl.formatMessage({id: "virtualMetricAdmin.joins.metricValueLabel"})
                  }
                  else if(item.join_column_id.includes("v")){
                    join_column_idLabel += intl.formatMessage({id: "virtualMetricAdmin.joins.metricValueLabel"}) + "." + metricsList.find(metric => metric.id==item.metric_id).object_definition.find(prop => prop.id == item.join_column_id.split("_")[1]).name
                  }
                  else{
                    join_column_idLabel += dimensionsList.find(dimension => dimension.id==item.join_column_id).name
                  }
                  itemInnerText += ": ("+foreign_metric_join_column_idLabel+" -> M. "+join_typeLabel+" -> "+join_column_idLabel+")"
                }
                if(item.order){
                  itemInnerText += " [Orden: "+item.order+"]"
                }
                return (
                  <div key={i} className={"free-text-list-list-item" + (incompleteData ? " free-text-list-list-item-required" : "") + (showAllTextInJoins ? " free-text-list-list-item-wrap" : "")}>
                    <div title={itemInnerText} className="free-text-list-list-item-inner">
                      {itemInnerText}
                    </div>
                    {!disabled && (
                      <div className="free-text-list-list-item-action-buttons">
                        <i 
                          className="fas fa-edit"
                          onClick={this.handleClickEdit}
                          data-index={i}
                          data-value={JSON.stringify(item)}
                        />
                        <i
                          className="fas delete-action fa-trash"                          
                          data-index={i}
                          data-delete={"true"}
                          data-objecteditor={"true"}
                          data-value={JSON.stringify(item)}
                          data-path={dataPath}
                          onClick={this.handleDeleteItem}
                        />
                      </div>
                    )}
                  </div>
                );
              }
            })}
            <div className="free-text-list-list-item free-text-list-list-item-add virtual_metric_join_selector">
              <div className="free-text-list-list-item-inner">
                {(!disabled && !blockAdd) && (
                  <div className="object-editor-inputs">                    
                    <div className="object-editor-inputs-linebreak">
                      <Select 
                        className="free-text-list-list-add-item"
                        value={this.state.toAddObject.metric_id}
                        labelLocale={<FormattedMessage id="virtualMetricAdmin.fields.joins.metric_id"/>}
                        options={metricOptions ? metricOptions : []}
                        onChange={this.handleChangeAddItem}
                        data-path={"metric_id"}
                      />
                      {values.length > 0 && (
                        <Select 
                          className="free-text-list-list-add-item metric_join_type_select"
                          value={this.state.toAddObject.join_type}
                          labelLocale={<FormattedMessage id="virtualMetricAdmin.fields.joins.join_type"/>}
                          options={InterfaceTooling.getSelectArray("selectKeys.virtualMetric.joinType","virtualMetricAdmin.joins.joinTypeOptions")}
                          onChange={this.handleChangeAddItem}
                          data-path={"join_type"}
                        />
                      )}
                      {/* <TextBox
                        className="free-text-list-list-edit-item"
                        styleType={Constants.interface.inputs.styleType.OUTLINED}
                        onChange={this.handleChangeAddItem}
                        data-path={"order"}
                        value={this.state.toAddObject.order}
                        onKeyEsc={this.handleCancelAdd}
                        onKeyEnter={this.handleOnEnterAddItem}
                        type={Constants.interface.inputs.type.TEXT}
                        labelLocale={<FormattedMessage id="virtualMetricAdmin.fields.joins.order"/>}
                      /> */}
                    </div>
                    {values.length > 0 && (
                      <React.Fragment> 
                        <div className="object-editor-inputs-linebreak">
                          <Select 
                            className="free-text-list-list-add-item"
                            value={this.state.toAddObject.foreign_metric_join_column_id}
                            labelLocale={<FormattedMessage id="virtualMetricAdmin.fields.joins.foreign_metric_join_column_id"/>}
                            options={foreignColumnIdOptions ? foreignColumnIdOptions : []}
                            onChange={this.handleChangeAddItem}
                            data-path={"foreign_metric_join_column_id"}
                          />                      
                          <Select 
                            className={"free-text-list-list-add-item" + (this.state.showOverlay ? " additional_input_required" : "")}
                            value={this.state.toAddObject.join_column_id}
                            labelLocale={<FormattedMessage id="virtualMetricAdmin.fields.joins.join_column_id"/>}
                            options={joinColumnIdOptions ? joinColumnIdOptions : []}
                            onChange={this.handleChangeAddItem}
                            data-path={"join_column_id"}
                            disabled={this.state.toAddObject.metric_id == ''}
                          />
                        </div>
                        <div className="object-editor-inputs-linebreak">
                          <Select 
                            className="free-text-list-list-add-item"
                            value={this.state.toAddObject.foreign_metric_join_column_transform}
                            labelLocale={<FormattedMessage id="virtualMetricAdmin.fields.joins.foreign_metric_join_column_transform"/>}
                            options={InterfaceTooling.getSelectArray("selectKeys.virtualMetric.joinColumnsTransformations","virtualMetricAdmin.joins.joinMetricTransformationOptions")}
                            onChange={this.handleChangeAddItem}
                            data-path={"foreign_metric_join_column_transform"}
                          />
                          <Select 
                            className="free-text-list-list-add-item form_buttons_item"
                            value={this.state.toAddObject.join_column_transform}
                            labelLocale={<FormattedMessage id="virtualMetricAdmin.fields.joins.join_column_transform"/>}
                            options={InterfaceTooling.getSelectArray("selectKeys.virtualMetric.joinColumnsTransformations","virtualMetricAdmin.joins.joinMetricTransformationOptions")}
                            onChange={this.handleChangeAddItem}
                            data-path={"join_column_transform"}
                          />
                        </div>
                      </React.Fragment> 
                    )}
                  </div>
                )}
              </div>
              {(!disabled && !blockAdd && this.state.showOverlay) && (
                <div className="free-text-list-list-item-action-buttons free-text-list-list-item-action-buttons-add">
                  <i 
                    ref={(input) => { this.addItemSaveButton = input; }}
                    className="fas fa-save"
                    data-objecteditor={"true"}
                    data-value={JSON.stringify(this.state.toAddObject)}
                    data-path={dataPath}
                    onClick={this.handleSaveAddItem}   
                  />
                  <i 
                    className="fas cancel-action fa-times-circle"
                    onClick={this.handleCancelAdd}
                  />
                </div>
              )}
            </div>
          </div>
      </div>
    );
  }
}

export default MetricJoinSelector;



// WEBPACK FOOTER //
// ./source/client/components/virtualMetricAdmin/metricJoinSelector.jsx